<template>
  <div class="app-notification">
    <v-icon :icon="icon" class="mr-2" />
    <div class="d-flex flex-column ga-3">
      <span v-html="message" />
      <v-btn v-if="options?.action" variant="tonal" @click="doAction">
        {{ options.action.label }}
      </v-btn>
    </div>

    <v-spacer />

    <v-btn-icon icon="mdi-close" @click="close" />
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import type { AppNotifyOptions } from '~/lib/notify'

export default defineComponent({
  name: 'AppNotification',
  props: {
    message: {
      type: String,
      required: true,
    },
    options: {
      type: Object as PropType<AppNotifyOptions | undefined>,
      required: false,
      default: undefined,
    },
  },
  emits: ['close-toast'],
  computed: {
    icon() {
      if (!this.options) {
        return ''
      }
      if (this.options.type === 'error') {
        return 'mdi-alert-circle'
      } else if (this.options.type === 'warning') {
        return 'mdi-alert'
      } else if (this.options.type === 'success') {
        return 'mdi-check-circle'
      } else if (this.options.type === 'info') {
        return 'mdi-information-variant-circle'
      }
      return ''
    },
  },
  methods: {
    doAction() {
      this.options?.action?.onClick?.()
      this.close()
    },
    close() {
      this.$emit('close-toast')
    },
  },
})
</script>
<style lang="scss">
.app-notification-wrapper {
  border-radius: 10px;
  background: white;
  box-shadow: 0 4px 18px -2px rgba(0, 0, 0, 0.2);
}
.app-notification {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 360px;
  padding: 16px;
}
</style>
